export { BarComponent } from './bar.component';
export { ProgressbarComponent } from './progressbar.component';
export { ProgressbarModule } from './progressbar.module';
export { ProgressbarConfig } from './progressbar.config';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/ngx-bootstrap/progressbar/index.js
// module id = ../../../../ngx-bootstrap/progressbar/index.js
// module chunks = 7